let Contracts = {
  SmartCityContract: "0xcaE4fB5cdA5f679c6dB7A7A4b2b08F1A4E6b59Ac",
};

export default Contracts;
